<template>
  <transition name="crossfade">
    <vue-draggable-resizable :parent="true" v-show="$route.name == 'home'" class-name="ks-applaus" :resizable="false" :z="1" :w="'auto'" :h="'auto'" :x="x" :y="y">
        <a target="_blank" href="https://projects.playables.net/beifall/210514-9/">
          <img :style="`transform: rotate(${a}deg)`" src="/static/images/applaus.svg">
        </a>
    </vue-draggable-resizable>
  </transition>
</template>

<script>

import VueDraggableResizable from 'vue-draggable-resizable'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'

export default {
  name: 'Applaus',
  components: { VueDraggableResizable },
  data () {
    return {
      x: Math.random() * (window.innerWidth - window.innerHeight * 0.25),
      y: Math.random() * (window.innerHeight - window.innerHeight * 0.25),
      a: Math.round(Math.random() * (360))
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

@import '../main';

.ks-applaus {
  z-index: 1;
  position: absolute;
  cursor: pointer;
  user-select: none;
  width: 16vw !important;
  height: 16vw !important;
  @include sm() {
    width: 15vh !important;
    height: 15vh !important;
  }
  border-radius: 50%;
  * {
    user-select: none;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Applaus.vue